import PropTypes from "prop-types";
import React from "react";

const SeriesTabs = ({ tabs, activeTab, onSelect }) => (
  <div className="series-tab-strip">
    {tabs.map((tab) => {
      const isActive = activeTab === tab.key;
      return (
        <button
          key={tab.key}
          type="button"
          onClick={() => onSelect(tab.key)}
          className={`btn btn-sm d-inline-flex align-items-center series-tab-pill ${isActive ? "active" : ""}`.trim()}
        >
          {tab.label}
          {tab.count != null && tab.count > 0 && (
            <span className="series-tab-count">{tab.count}</span>
          )}
        </button>
      );
    })}
  </div>
);

SeriesTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number,
  })).isRequired,
  activeTab: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SeriesTabs;
